import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/esm/Button';
import '../forms/Form.css';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function FormGroupExample({ modalStatus,setShowModal, products, setProducts,handleClose }) {

  const [formData, setFormData] = useState({
    title: '',
    price: '',
    category: '',
    image: '',
    description: '',
  });

  const handleAddProd = async () => {
  try {
    const product = formData;
    const result = await axios.post('https://fakestoreapi.com/products', product);
    console.log("Product added:", result.data);  // ✅ Check if this shows
    setProducts(prev => [...prev, result.data]); // ✅ use functional update
    setShowModal(false);
    toast.success("Item Added Successfully!✅️");
  } catch (error) {
    console.error("Error adding product:", error);
  }
};

   

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className='form-wrapper'>
      <h1>Add Product</h1>
      <Form>
        <div>
        <Form.Group className="mb-3" controlId="formGroupTitle">
          <Form.Label>Title</Form.Label>
          <Form.Control type="text" name="title" value={formData.title} onChange={handleChange} />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formGroupPrice">
          <Form.Label>Price</Form.Label>
          <Form.Control type="text" name="price" value={formData.price} onChange={handleChange} />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formGroupCategory">
          <Form.Label>Category</Form.Label>
          <Form.Control type="text" name="category" value={formData.category} onChange={handleChange} />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formGroupImage">
          <Form.Label>Image URL</Form.Label>
          <Form.Control type="text" name="image" value={formData.image} onChange={handleChange} />
        </Form.Group>
        <Form.Group className="mb-5" controlId="formGroupDescription">
          <Form.Label>Description</Form.Label>
          <Form.Control type="text" name="description" value={formData.description} onChange={handleChange} />
        </Form.Group>
        <Button variant="primary" onClick={handleAddProd}>Add Product</Button>
        </div>
      </Form>
    </div>
  );
}

export default FormGroupExample;

